import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { DatePicker, Dropdown } from "components";
import { useRegisterNavAction } from "hooks";
import { EXACT_ACTIONS } from "models";
import "modules/ExactMonitoring/components/ApiErrors/ApiErrors.scss";
import { ExactFailuresTable, StatusCodeFilter } from "modules/ExactMonitoring/components/ApiErrors/components";
import { setExactMonitoringFilters, useExactMonitoringFilters, useExactMonitoringQuery } from "modules/ExactMonitoring/components/ApiErrors/hooks";
import { enumToDropdownOptions } from "utils/common";

export const ApiErrors = () => {
  const { t } = useTranslation();

  const filters = useExactMonitoringFilters();
  const { page: currentPage, action, date_from, date_to } = filters;
  const { data, isLoading, refetch: refetchFailures, isRefetching } = useExactMonitoringQuery();
  const actionOptions = useMemo(() => enumToDropdownOptions({ enumObj: EXACT_ACTIONS, t }), [t]);

  useRegisterNavAction(refetchFailures);

  const handleDateChange = (...dates: (Date | null)[]) => {
    const [start, end] = dates;
    setExactMonitoringFilters({ ...filters, date_from: start, date_to: end, page: 1 });
  };

  const handlePageChange = (pagination: { activePage: number }) => setExactMonitoringFilters({ ...filters, page: pagination.activePage });

  return (
    <div className="ApiErrors">
      <div className="filters-container">
        <Grid columns={16}>
          <Grid.Row>
            <Grid.Column width={6}>
              <Dropdown
                clearable
                placeholder={t("v8_select_an_action", "Select an action")}
                options={actionOptions}
                value={action ?? undefined}
                fluid
                selection
                search
                selectOnBlur={false}
                multiple={false}
                onChange={value => setExactMonitoringFilters({ ...filters, action: value ?? null, page: 1 })}
              />
            </Grid.Column>

            <Grid.Column width={6}>
              <StatusCodeFilter />
            </Grid.Column>

            <Grid.Column width={4}>
              <DatePicker startDate={date_from} endDate={date_to} onDateChange={handleDateChange} selectsRange showLabel clearable fluid />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>

      <ExactFailuresTable
        failures={data?.failures}
        activePage={currentPage}
        totalPages={data?.nb_pages || 1}
        onPageChange={handlePageChange}
        totalItems={data?.nb_items || 0}
        isRefetching={isRefetching}
        isLoading={isLoading}
      />
    </div>
  );
};
